import propertyOrNull from '../../../utils/app/propertyOrNull';

// Translate from HAL API to local data structure
function fromJSON(json: any) {
    if (!json) {
        return null;
    }

    const data = {
        messageHtml: propertyOrNull(json, 'messageHtml'),
        isRead: propertyOrNull(json, 'isRead'),
        icon: propertyOrNull(json, 'icon'),
        thumbnailUrl: propertyOrNull(json, 'thumbnailUrl'),
        destinationUrl: propertyOrNull(json, 'destinationUrl'),
        lastActivityAt: propertyOrNull(json, 'lastActivityAt'),
        links: {
            self: propertyOrNull(json._links.self, 'href'),
        },
    };

    return data;
}

export default { fromJSON };
